import ArtistShowcase from './ArtistShowcase';

export default ArtistShowcase;
